

import Iframe from "react-iframe";
import Flip from 'react-reveal/Flip';
import LightSpeed from 'react-reveal/LightSpeed';
import Wobble from 'react-reveal/Wobble';
// const initialState = {
// 	name: "",
// 	email: "",
// 	message: "",
// };
export const Contact = (props) => {
	// const [{ name, email, message }, setState] = useState(initialState)

	// const handleChange = (e) => {
	//   const { name, value } = e.target
	//   setState((prevState) => ({ ...prevState, [name]: value }))
	// }
	// const clearState = () => setState({ ...initialState })

	// const handleSubmit = (e) => {
	//   e.preventDefault()
	//   console.log(name, email, message)
	//   emailjs
	//     .sendForm(
	//       'YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target, 'YOUR_USER_ID'
	//     )
	//     .then(
	//       (result) => {
	//         console.log(result.text)
	//         clearState()
	//       },
	//       (error) => {
	//         console.log(error.text)
	//       }
	//     )
	// }
	return (
		<div>
			<div id="contact">
				<div className="container">
					<div className="col-md-8">
						<div className="row">
							<Flip bottom duration={2000}>
							<div className="section-title">
								<h2>Terimakasih telah berkunjung di website kami</h2>
							</div>
							</Flip>
							<LightSpeed right duration={2000}>
							<img src="img/lastbg.jpg" className="img-responsive" alt="" />{" "}
							</LightSpeed>
							{/* <form name='sentMessage' validate onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='name'
                        name='name'
                        className='form-control'
                        placeholder='Name'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='email'
                        id='email'
                        name='email'
                        className='form-control'
                        placeholder='Email'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                <div className='form-group'>
                  <textarea
                    name='message'
                    id='message'
                    className='form-control'
                    rows='4'
                    placeholder='Message'
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p>
                </div>
                <div id='success'></div>
                <button type='submit' className='btn btn-custom btn-lg'>
                  Send Message
                </button>
              </form> */}
						</div>
					</div>
					<Flip bottom duration={2000}>
					<div className="col-md-3 col-md-offset-1 contact-info">
						<div className="contact-item">
							<h3>Info Kontak</h3>
							<p>
								<span>
									<i className="fa fa-map-marker"></i> Alamat
								</span>
								{props.data ? props.data.address : "loading"}
							</p>
						</div>
						<div className="contact-item">
							<p>
								<span>
									<i className="fa fa-phone"></i> No. Telp
								</span>{" "}
								{props.data ? props.data.phone : "loading"}
							</p>
						</div>
						<div className="contact-item">
							<p>
								<span>
									<i className="fa fa-envelope-o"></i> Email
								</span>{" "}
								{props.data ? props.data.email : "loading"}
							</p>
						</div>
					</div>
					<div className="col-md-12">
						<div className="row">
							<div className="social">
								<ul>
									{/* <li>
                    <a href={props.data ? props.data.facebook : '/'}>
                      <i className='fa fa-facebook'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : '/'}>
                      <i className='fa fa-twitter'></i>
                    </a>
                  </li> */}
									<li>
										<a href="https://www.youtube.com/channel/UCU5zOTh37yUpAdnI8OESpQQ/videos">
											<i className="fa fa-youtube"></i>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					</Flip>
				</div>
				<div className="container text-center">
				<h1 style={{marginBottom : "2rem"}}>Lokasi Kami</h1>
				{/* <Map 
				mapLib={maplibregl}
				initialViewState={{
					langitude:-3.438315,
					longitude:114.830342,
					zoom: 6
				}}
				
				style={{width: 600, height: 400}}
				mapStyle="https://api.maptiler.com/maps/streets-v2/style.json?key=UgBajIIEKAuaQrruPYhy">
					<NavigationControl position='top-left' />
					</Map> */}
				<Wobble duration={2000}>
					<Iframe className="lokasi" src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=mtsn 3 tabalong&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" />
				</Wobble>
					
			</div>
			</div>
		
			<div id="footer">
				<div className="container text-center">
					<p>
						&copy; 2022 MTSN 3 Tabalong. Design by{" "}
						<a href="https://www.instagram.com/cahayaa_murnii/" rel="nofollow">
							Cahaya Murni
						</a>
					</p>
				</div>
			</div>
		</div>
	);
};
